import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', () => {
  const { purgeLocalStorage } = usePersistedSettings()

  // Personal data is kept in memory only: never written to browser storage
  const email = ref('')
  const phone = ref('')

  const setEmail = (value: string) => {
    email.value = value
  }

  const setPhone = (value: string) => {
    phone.value = value
  }

  onMounted(() => {
    // Remove values persisted by previous versions
    purgeLocalStorage('USER:')
  })

  return {
    email,
    phone,

    setEmail,
    setPhone,
  }
})
